import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import { App } from "./App"
import reportWebVitals from "./reportWebVitals"

const dismissWebpackOverlay = () => {
  document.getElementById("webpack-dev-server-client-overlay")?.remove()
}

// Backup for the early listener in public/index.html — CRA overlay treats this
// benign AG Grid / antd tooltip warning as a crash.
window.addEventListener("error", e => {
  const msg = `${e.message} ${(e.error as Error | null)?.message ?? ""}`
  if (!msg.includes("ResizeObserver loop")) return
  e.stopImmediatePropagation()
  e.preventDefault()
  dismissWebpackOverlay()
  requestAnimationFrame(dismissWebpackOverlay)
}, true)

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
)
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
